<!-- <div class="flex min-h-screen">
    <app-sidebar *ngIf="showSidebar" (toggle)="toggleSidebar($event)"></app-sidebar>
    <app-nav></app-nav>
    
    
    <div [ngClass]="{
      'ml-[15%] max-w-[85%]': isExpanded && showSidebar,
      'ml-[5%] max-w-[95%]': !isExpanded && showSidebar,
      'ml-0': !showSidebar
    }" class="flex-1 transition-all duration-300 ">
    <app-banner *ngIf="showSidebar" [titleComponent]="titleFromParent" ></app-banner>
        <router-outlet></router-outlet>
    </div>
</div> -->

<div class="flex flex-col min-h-screen">
  <div class="flex flex-1 w-full">

    <ng-container *ngIf="showSidebar && userRol && !['paciente','logistico'].includes(userRol)">
      <app-sidebar (toggle)="toggleSidebar($event)"></app-sidebar>
    </ng-container>

    <div class="flex-1 transition-all duration-300"
      [style.marginLeft]="sidebarVisible() ? (isExpanded ? '10%' : '5%') : '0'"
      [style.maxWidth]="sidebarVisible() ? (isExpanded ? '90%' : '95%') : '100%'" [class.pb-28]="showNavBottom">

      <app-banner *ngIf="showSidebar && showBanner" [titleComponent]="titleFromParent"></app-banner>
      <app-header-movile *ngIf="(showNavBottom || showSidebar) && userRol === 'paciente'"></app-header-movile>
      <app-nav *ngIf="(showNavBottom || showSidebar) && userRol !== 'paciente'"></app-nav>
      <router-outlet></router-outlet>
    </div>

  </div>
</div>